import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "footage-in-investigations",
  courseId: "investigations",
  order: 7,
  title: "Investigation footage",
  summary:
    "Video uploaded to an investigation is watched the same way as case footage. Leads anchor to a second of video, and the chat can answer from what was seen.",
  learn: [
    "Upload video to an investigation",
    "Open video-anchored leads",
    "Ask the chat about what the footage shows",
  ],
  minutes: 3,
  releasedAt: "2026-09-24T00:00:00.000Z",
  gate: "video",
  body: [
    {
      type: "paragraph",
      text: "Drop a video on the investigation's Files tab and it goes through frame extraction and the two-pass watch, in addition to transcription. The investigation prompt looks for the same things it looks for in calls: your focus, known people, places, and objects.",
    },
    {
      type: "steps",
      items: [
        "Upload the video like any other file. It is listed on the Files tab, not under Calls, and has its own viewer.",
        "Open the file. The player, marker bar, and points of interest work as they do in the case editor, with the transcript below.",
        "Open the Leads tab. Leads from the video carry a video anchor, and clicking one seeks the player to that second.",
        "Open Mentions. Entities seen on video are added there with their times.",
        "Open the Timeline. Dated moments from the video feed it.",
        "In chat, ask about the footage directly. The assistant has a video-events tool and cites video segments.",
      ],
    },
    {
      type: "callout",
      tone: "note",
      title: "Video costs more of the pool",
      text: "Each minute of footage counts as three minutes of allowance, because of the frame analysis on top of the transcript.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Silent footage (no audio track) skips transcription and is analyzed visually only. It still produces leads and events.",
    },
    {
      type: "paragraph",
      text: "\"The Footage tab\" describes the player and marker bar. \"Work the leads queue\" covers what to do with the leads.",
    },
  ],
  related: ["the-footage-tab", "documents-spreadsheets-photos", "work-the-leads-queue"],
};

export default lesson;
